import { Person } from "../../../types";
import { useEffect, useState } from "react";
import { getPersonApi } from "../../../api/resources.api";

export function usePersonsLoadMore() {
  const [page, setPage] = useState(1);
  const [persons, setPersons] = useState<Person[]>([]);
  const [loadingMore, setLoadingMore] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  // initial load
  useEffect(() => {
    const fetchInitial = async () => {
      try {
        setIsLoading(true);

        const res = await getPersonApi({ page: 1 });

        setPersons(res.data ?? []);
        setHasMore(res.meta?.has_more_pages ?? false);
      } finally {
        setIsLoading(false);
      }
    };

    fetchInitial();
  }, []);

  const loadMore = async () => {
    if (loadingMore || !hasMore) return;

    try {
      setLoadingMore(true);

      const nextPage = page + 1;
      const secondPage = page + 2;

      const [res1, res2] = await Promise.all([
        getPersonApi({ page: nextPage }),
        getPersonApi({ page: secondPage }),
      ]);

      const merged = [...(res1.data ?? []), ...(res2.data ?? [])];

      setPersons((prev) => {
        const map = new Map<number, Person>();

        [...prev, ...merged].forEach((item) => {
          map.set(item.id, item);
        });

        return Array.from(map.values());
      });

      setPage(secondPage);

      setHasMore(
        res2.meta?.has_more_pages ?? res1.meta?.has_more_pages ?? false,
      );
    } finally {
      setLoadingMore(false);
    }
  };

  return {
    persons,
    loadMore,
    loadingMore,
    hasMore,
    isLoading,
  };
}
